import { render, staticRenderFns } from "./HeartDashboardItem.vue?vue&type=template&id=b608204a&scoped=true"
import script from "./HeartDashboardItem.vue?vue&type=script&lang=js"
export * from "./HeartDashboardItem.vue?vue&type=script&lang=js"
import style0 from "./HeartDashboardItem.vue?vue&type=style&index=0&id=b608204a&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b608204a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/admin-ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b608204a')) {
      api.createRecord('b608204a', component.options)
    } else {
      api.reload('b608204a', component.options)
    }
    module.hot.accept("./HeartDashboardItem.vue?vue&type=template&id=b608204a&scoped=true", function () {
      api.rerender('b608204a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Dashboard/Items/HeartDashboardItem.vue"
export default component.exports